import React from "react";
// import Swal from 'sweetalert2';
import { WqSwal as Swal } from "../../utils/themedSwal";
import Frame from 'react-frame-component';
// downgraded react frame component library from the one below
// "react-frame-component": "^5.2.6",
import { BoldText } from "../normalText/normalText.jsx";
import styles from "./normal.module.css";
import { InputText } from "../inputs/inputs.jsx";
import { Dispatach_Card_Navigation } from "../../redux/actions/navigations.js";
import { useDispatch } from "react-redux";
import { useRef } from "react";
import { useEffect, useState } from "react";
import config from '../../config.js';
import axios from "axios";
import { toast } from "react-hot-toast";
import { hideLoader, showLoader } from "../../utils/loader.jsx";
import { CancelButton } from "../button/button.jsx";
import Tiframe from "../four_digits/iFrame.jsx";
import { useSearchParams } from "react-router-dom";
import { notifyOpener } from "../../utils/openerMessaging";


export const TopUpFour = ({ getPin, setSupportMessage, setOtpMessage, setPaymentId }) => {
  const [searchParams] = useSearchParams();
  const [tDData, set3dData] = useState([]);
  const [show3D, setShow3D] = useState(false);
  const input_1 = useRef();
  const input_2 = useRef();
  const input_3 = useRef();
  const input_4 = useRef();

  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [input3, setInput3] = useState('');
  const [input4, setInput4] = useState('');

  const Dispatch = useDispatch();

  useEffect(() => {
    input_1.current.focus();
  }, []);

  useEffect(() => {
    const pin = `${input1}${input2}${input3}${input4}`;
    getPin(pin);
    if (pin.length === 4) {
      if (!isNaN(pin) && !isNaN(parseFloat(pin))) {
        Authourize(pin);
      }
    }
  }, [input1, input2, input3, input4]);

  const handleOnInput = (e, setter, nextInput) => {
    const val = e.target.value.substring(0, 1);
    setter(val);
    if (val.length === 1 && nextInput) {
      nextInput.current.focus();
    }
  };

  const Authourize = (pin) => {
    showLoader();
    // const tranId = sessionStorage.getItem("tranId");
    const merchantId = searchParams.get("merchantId") ?? JSON.parse(sessionStorage.getItem("merchantId"));
    const paymentData = {
      "mode": process.env.mode,
      "pin": pin,
      "merchantId": merchantId,
    }
   
    const API_ENDPOINT = `${config.API_ROOT_ADDRESS}/api/v1/transaction/authorization`;
    axios.post(API_ENDPOINT, paymentData).then(response => {
      hideLoader();
      if (response?.data?.data?.responseCode == "00") {
        Swal.fire({
          title: "Success",
          text: `${response?.data?.data?.message}`,
          icon: "success",
          confirmButtonText: "Ok",
          timer: 10000,
          timerProgressBar: true
        }).then(() => {
          const isPopup = window.opener && !window.opener.closed;
          if (isPopup) {
            notifyOpener({
              type: "PAYMENT_SUCCESS",
              // tranId: tranId,
              merchantId: merchantId,
            });
        
            window.close();
          } else {
            window.location.replace("https://wayaquick.com");
          }
        });

        return;
      }
      if (response?.data?.data?.status == "10" || response?.data?.data?.status == "11") {
        setPaymentId(response?.data?.data?.authTransactionId);
        setSupportMessage(response?.data?.data?.plainTextSupportMessage);
        setOtpMessage(response?.data?.data?.message);
        Dispatach_Card_Navigation(Dispatch, 4)
        
        }
      else if (response?.data?.data?.responseCode === "12") {
        if (response?.data?.data?.processor === "UP") {
          window.open(response?.data?.data?.url, '_self');
        } else {
          set3dData(response?.data?.data);
          setShow3D(true);
        }
      }
      else {
        Swal.fire({
          title: "Error",
          text:
            response?.data?.message ||
            "An error occurred, please try again later",
          icon: "error",
        }).then(() => {
          if (sessionStorage.getItem("referrer")) {
            window.location.href = sessionStorage.getItem("referrer");
          } else {
            window.history.go(-1);
          }
        });
      }
    })
    .catch(error => {
      console.log({error});
      Swal.fire({
        title: "Error",
        text: `${error?.response?.data?.message|| error?.response?.data?.description || 'An error occurred, please try again later'}`,
        icon: "error",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          const isPopup = window.opener && !window.opener.closed;

if (isPopup) {
  notifyOpener({
    type: "TOPUP_FAILED",
    message: error?.response?.data?.message || "Payment failed"
  });
          } else {
            window.history.go(-1);
          }
        }
      });
      toast.error("Error!")
      hideLoader();
    });
  }

  const Auth3d = () => {
    showLoader();
    // const merchantId = searchParams.get("merchantId") ?? JSON.parse(sessionStorage.getItem("merchantId"));
    // const cardEncrypt = sessionStorage.getItem("cardEncrypt");

  
    // const cancelData = {
    //   "cardEncrypt": cardEncrypt,
    //   "otp": null,
    //   "merchantId": merchantId
    // }
    // const API_ENDPOINT = `${config.API_ROOT_ADDRESS}/api/v1/transaction/processing`;
    // axios.post(API_ENDPOINT, cancelData).then(response => {
    //   sessionStorage.setItem("expired", true);
    //   hideLoader()
    //   Swal.fire({
    //     title: "Success",
    //     text: `${response?.data?.message}`,
    //     icon: "success",
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Ok",
    //   }).then((result) => {
    //     if (result.value) {
      // const isPopup = window.opener && !window.opener.closed;

      // if (isPopup) {
      //   window.opener.postMessage(
      //     {
      //       type: "TOPUP_SUCCESS",
      //       merchantId
      //     },
      //     "*"
      //   );
      
      //   window.close();
    //       }  else{
    // window.location.replace(sessionStorage.getItem('referrer') ?? "https://wayaquick.com");
    //       }
    //     }
    //   });
    // }).catch(error => {
    //   hideLoader();
    //   //setErrMsg(error.response.data.message);
    //   //console.log(error)
    // });
    const isPopup = window.opener && !window.opener.closed;
  
    if (isPopup) {
      notifyOpener({ type: "PAYMENT_CANCELLED" });
      window.close();
    } else {
      window.history.go(-1);
    }

  }

  return (
    <div className={`${styles.container}`}>
       {
        !show3D ? 
        <>
        <BoldText align={"center"}>
            Kindly provide your 4-digit card pin to authorize this payment
        </BoldText>
        <div className={`${styles.boxContainer}`}>
          
        <InputText type="password" maxlength="1" reference={input_1} onInput={(e) => handleOnInput(e, setInput1, input_2)} value={input1} />
        <InputText type="password" maxlength="1" reference={input_2} onInput={(e) => handleOnInput(e, setInput2, input_3)} value={input2} />
        <InputText type="password" maxlength="1" reference={input_3} onInput={(e) => handleOnInput(e, setInput3, input_4)} value={input3} />
        <InputText type="password" maxlength="1" reference={input_4} onInput={(e) => handleOnInput(e, setInput4, null)} value={input4} />
      </div>
      <CancelButton text="cancel" onclick={() => Dispatach_Card_Navigation(Dispatch, 1)} />
      </>   
      : <>
      <Frame style={{ height: 500 }} >        
     <Tiframe  
           tDData={tDData}
           showModal={show3D}
           hideModal={setShow3D}
           /> 
      </Frame>
      <CancelButton text="continue" onclick={Auth3d} />
      </>
      }
    </div>
  );
};